import { PolicyUsage } from "@covertree/new-business-graphql";
import { HomeUsage } from "@covertree/types";

export function getHomeUsageBasedOnPolicyUsage(
  policyUsage?: PolicyUsage
): HomeUsage | undefined {
  if (policyUsage === PolicyUsage.Owner) {
    return HomeUsage.MainResidence;
  }

  if (policyUsage === PolicyUsage.Seasonal) {
    return HomeUsage.SeasonalResidence;
  }

  if (policyUsage === PolicyUsage.Vacant) {
    return HomeUsage.HomeIsVacant;
  }

  return undefined;
}
